const STORAGE_KEY = 'argus.pendingCombineClaim.v1'

function storage() {
  try {
    return globalThis.localStorage ?? null
  } catch {
    return null
  }
}

export function rememberPendingCombineClaim(token) {
  const normalized = String(token ?? '').trim()
  if (normalized.length < 32 || normalized.length > 200) return false
  try {
    storage()?.setItem(STORAGE_KEY, normalized)
    return true
  } catch {
    return false
  }
}

export function readPendingCombineClaim() {
  try {
    const token = storage()?.getItem(STORAGE_KEY) ?? ''
    return token.length >= 32 && token.length <= 200 ? token : ''
  } catch {
    return ''
  }
}

export function clearPendingCombineClaim() {
  try {
    storage()?.removeItem(STORAGE_KEY)
  } catch {
    // The claim may still be completed in the current page if storage is unavailable.
  }
}

export function pendingCombineClaimPath(token = readPendingCombineClaim()) {
  return token ? `/combine/claim?token=${encodeURIComponent(token)}` : ''
}
